import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { IoptionElemet } from '../../../shared/interfaces/IoptionElemet';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';

@Component({
  selector: 'gen-add-aberration',
  templateUrl: './add-aberration.component.html',
  styleUrls: ['./add-aberration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddAberrationComponent implements OnInit, OnDestroy {

  public payload: { formName: string, aberrationType: string, options: IoptionElemet[] };
  public tunnel$: Subject<any>;
  public callback: (model) => Observable<Response>;
  public selectedFormName: string;
  public form: any;
  public submitted: boolean;
  private isValid: boolean;
  private aberrationType: string;

  constructor(private _changeDetector: ChangeDetectorRef) {
  }

  @Input() set selectedFormNameListener(data) {
    this.selectedFormName = data;
  };

  ngOnInit() {
    this.tunnel$.asObservable().filter(value => value.emitter !== 'child').subscribe(next => {
      next.value && this.submit(this.payload);
    });
    this.selectedFormName = this.payload.options[0].code;
    this.aberrationType = this.payload.aberrationType;
  }

  ngOnDestroy(): void {
    this._changeDetector.detach();
  }

  submit(model) {
    this.submitted = true;
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
    if (!this.isValid) {
      return;
    }

    model = this.form;
    model['selectedFormName'] = this.selectedFormName;
    model = this.getDataFromFormTempFunc(model);

    this.callback(model).subscribe((model) => {
      this.tunnel$.next({ emitter: 'child', value: model});
    });
  }

  private getDataFromFormTempFunc(model) {
    for (const key in model) {
      if (model[key] == '' || model[key] == null) {
        delete model[key];
      }
      // 'disease' and 'additionalCurationProperties' are the only values that works with hierarchy
      if (typeof model[key] === 'object' && key != 'disease' && key != 'additionalCurationProperties') {
        /*if (key === 'disease'){
          model['diseaseDisplay'] = model[key].display
          model['disease'] = model[key].code
        }
        else*/
        if (model[key].display) {
          model[key] = model[key].display;
        }
        else if (model[key].CommonName) {
          model[key] = model[key].CommonName;
        }
      }
    }
    model['AberrationClass'] = this.aberrationType;
    return model;
  }

  updateValidate(validate: boolean) {
    this.isValid = validate;
  }


  typeClick(selectedType: string){
    this.selectedFormName = selectedType;
  }
}
